export default __webpack_public_path__ + "static/media/automate.a8152b52.JPG";